import { render, staticRenderFns } from "./pendingReview.vue?vue&type=template&id=d75104ac&scoped=true"
import script from "./pendingReview.vue?vue&type=script&lang=js"
export * from "./pendingReview.vue?vue&type=script&lang=js"
import style0 from "./pendingReview.vue?vue&type=style&index=0&id=d75104ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75104ac",
  null
  
)

export default component.exports